import { motion } from "framer-motion";

interface ProgressBarProps {
  progress: number;
}

export function ProgressBar({ progress }: ProgressBarProps) {
  return (
    <div className="h-1.5 bg-white/30 overflow-hidden shrink-0" role="progressbar" aria-valuenow={Math.round(progress)} aria-valuemin={0} aria-valuemax={100}>
      <motion.div
        className="h-full bg-white"
        style={{ width: `${progress}%` }}
        initial={false}
        transition={{ duration: 0.3 }}
      />
    </div>
  );
}
